import { memo } from "react";

import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import {
  FindingSeverity,
  FindingSeverityLabel,
  FindingSeverityColor,
  FindingSeverityNameToIntMap,
} from "stores/FindingStore";

// -----------------------------------------------------------------------------

const SeverityDropdown = memo(function OrganizationFindingBulkActions({
  severity,
  onChange,
}: SeverityDropdownProps): JSX.Element | null {
  return (
    <FormControl fullWidth>
      <InputLabel id="severity-label">New Severity</InputLabel>
      <Select
        labelId="select-severity-label"
        value={severity}
        label="New Severity"
        onChange={(event) => {
          onChange(event.target.value);
        }}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            <Chip
              key={severity}
              label={severity}
              color={
                FindingSeverityColor[
                  FindingSeverityNameToIntMap[severity]
                ] as any
              }
              sx={{ fontWeight: "bold" }}
            />
          </Box>
        )}
      >
        {(Object.keys(FindingSeverity) as Array<keyof typeof FindingSeverity>)
          .filter((k) => FindingSeverity[k] > FindingSeverity.EarlyAccessInfo)
          .sort((a, b) => {
            return FindingSeverity[b] - FindingSeverity[a];
          })
          .map((key) => {
            const label = FindingSeverityLabel[FindingSeverity[key]];
            return (
              <MenuItem key={label} value={label}>
                <Chip
                  key={label}
                  label={label}
                  color={FindingSeverityColor[FindingSeverity[key]] as any}
                  sx={{ fontWeight: "bold" }}
                />
              </MenuItem>
            );
          })}
      </Select>
    </FormControl>
  );
});

export default SeverityDropdown;

// -----------------------------------------------------------------------------

interface SeverityDropdownProps {
  severity: string;
  onChange: Function;
}
